module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/92/assets/images/52c8c981eac4f08825938bc2d8d929bc.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Platinum/Platinum2.svg
// module id = jLtQ
// module chunks = 1